import { useCallback } from 'react';
import { useNotification } from './useNotification';

export function useApiCall() {
  const notify = useNotification();
  return useCallback(async (promise, fallbackMessage = 'Error inesperado') => {
    try {
      return await promise;
    } catch (err) {
      notify(err.userMessage || fallbackMessage, 'error');
      throw err;
    }
  }, [notify]);
}
